import React from "react";
import Header from "../components/layouts/Header";
import Footer from "../components/layouts/Footer";

const NotFound = () => {
  return (
    <div>
      {/* <Header /> */}
      <div className="not-found-container">
        <div className="not-found-content">
          <div className="not-found-left">404</div>
          <div className="not-found-right">Oops! That page can’t be found.</div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default NotFound;
